/* eslint-disable react-hooks/exhaustive-deps */
import images from "../../assets/images/assets";
import cards from "../../assets/images/cards/cards";
import InstaLink from "../SmallComponents/InstaLink";
import SectionImage from "../SmallComponents/SectionImage";

import { useState, useEffect } from "react";

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [prevImageIndex, setPrevImageIndex] = useState(null); // Store previous image

  const decorSwitch = [
    cards.card_013,
    cards.card_023,
    cards.card_020,
    cards.card_021,
    cards.card_024,
    cards.card_025,
    cards.card_016,
    cards.card_018,
    cards.card_026,
    cards.card_027,
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setPrevImageIndex(currentImageIndex); // Save old image before switching
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % decorSwitch.length);
    }, 4000); // Change every 4 seconds

    return () => clearInterval(intervalId);
  }, [currentImageIndex]);

  return (
    <div className="bg-transparent w-full p-4 text-prime-red ">
      <div className="bg-transparent h-[80vh] lg:h-screen col items-center relative">
        {/* Hero Title */}
        <h2 className="text-3xl md:text-4xl mb-2 text-center w-2/3 playfair-display italic lg:absolute left-20 lg:w-1/5 lg:text-left lg:top-14 2xl:w-1/5 2xl:text-5xl">
          Crafting Moments into Memories.
        </h2>

        {/* Decorative Elements */}
        <img
          src={images.blur}
          alt="blur"
          className="absolute -right-18 md:-right-54 md:top-10 lg:top-0 top-48 saturate-200 "
        />

        <img
          src={images.leaves}
          alt="green-leaves"
          className="absolute -right-16 bottom-24 md:right-14 md:bottom-40 lg:right-[22.5%] lg:bottom-0 2xl:bottom-60 3xl:bg-rose-500     2xl:right-[27.5%] w-40 md:w-44 z-[100]"
        />

        <img
          src={images.flowers}
          alt="green-leaves"
          className="hidden md:block absolute -left-4 top-40 lg:left-48 lg:top-58 w-32 lg:w-36 z-[9999]"
        />

        {/* Hero-Image */}
        <SectionImage />

        {/* TagText */}
        <div className="col black-text text-center justify-center items-center mt-4 montserrat lg:absolute right-0 lg:w-1/4 top-10 text-prime-red 2xl:w-1/5 2xl:text-lg">
          <img src={images.star2} alt="decorative" className="w-5 mb-2" />
          <p className="w-3/4 montserrat">
            Welcome to our design space, where all events begin here.
          </p>
        </div>

        {/* Instagram Link */}
        <div className="mt-4 md:mt-5 lg:absolute bottom-20 left-10 2xl:bottom-60 ">
          <InstaLink />
        </div>

        {/* Decorative Image with Crossfade */}
        <div className="hidden lg:block absolute w-[170px] h-[264px] bottom-10 right-20 2xl:bottom-60 rounded-t-full rounded-bl-full saturate-150 overflow-hidden">
          {/* Previous Image - Fading Out */}
          {prevImageIndex !== null && (
            <div
              style={{ backgroundImage: `url(${decorSwitch[prevImageIndex]})` }}
              className="absolute inset-0 bg-cover bg-center transition-opacity duration-2000 ease-in-out opacity-0"
            ></div>
          )}

          {/* Current Image - Fading In */}
          <div
            style={{
              backgroundImage: `url(${decorSwitch[currentImageIndex]})`,
            }}
            className="absolute inset-0 bg-cover bg-center transition-opacity duration-2000 ease-in-out opacity-100"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
